<template>
  <div class="progress-wrapper">
    <svg width="100" height="100">
      <circle
        cx="50"
        cy="50"
        r="45"
        fill="none"
        stroke="#d6d6d6"
        stroke-width="5"
      />
      <circle
        v-if="displayProgress > 0"
        cx="50"
        cy="50"
        r="45"
        fill="none"
        :stroke="color"
        stroke-width="5"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="offset"
        stroke-linecap="round"
        transform="rotate(-90 50 50)"
      />
      <text
        x="47%"
        y="50%"
        text-anchor="middle"
        stroke="#000"
        dy=".3em"
        font-size="25"
        style="font-weight: 300"
      >
        {{ Math.round(displayProgress) }}
      </text>
      <text
        :x="labelPosition"
        y="46%"
        text-anchor="end"
        stroke="#918c8c"
        font-size="15"
        style="font-weight: 200"
      >
        %
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  name: "CircularProgress",
  props: {
    progress: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: "#3498db",
    },
  },
  data() {
    return {
      displayProgress: 0, // Initial display progress
      animationInterval: null, // Interval ID for animation
    };
  },
  computed: {
    labelPosition() {
      if(this.progress === 100) {
        return '80%'
      }
      else if (this.progress < 10) {
        return '70%'
      }
      return '75%'
    },
    circumference() {
      return 2 * Math.PI * 45; // 45 is the radius of the circle
    },
    offset() {
      return (
        this.circumference - (this.displayProgress / 100) * this.circumference
      );
    },
  },
  watch: {
    progress(newValue) {
      // Check if progress is already at the target
      if (newValue === 100) {
        this.displayProgress = 100;
        clearInterval(this.animationInterval); // Stop the interval if already at 100%
        return;
      }

      // Only start animation if not already animating
      if (!this.animationInterval) {
        const animationDuration = 1000; // duration in milliseconds
        const frameDuration = 16; // approx 60 FPS
        let frames = animationDuration / frameDuration;
        let step = (newValue - this.displayProgress) / frames;
        this.animationInterval = setInterval(() => {
          this.displayProgress += step;
          if (Math.abs(this.displayProgress - newValue) < Math.abs(step)) {
            this.displayProgress = newValue; // Ensure it ends exactly at progress
            clearInterval(this.animationInterval);
            this.animationInterval = null; // Reset animation interval
          }
        }, frameDuration);
      }
    },
  },
  mounted() {
    // Initialize display progress to match initial progress value
    this.displayProgress = this.progress;
  },
};
</script>

<style scoped>
.progress-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
}
</style>
